import * as React from 'react';

import Grid from '@mui/material/Grid';

import { REVENUE_DETAILS } from '../constants';
import { RevenueCardDetail } from './index';

function RevenueCardDetailsSection() {
  return (
    <Grid
      className={'home-page__revenue-details-section-container'}
      item={true}
      xs={10}
      lg={8}
      data-qa="revenue-card-details-section"
    >
      <RevenueCardDetail id={'home-page__revenue-revenue'} cardInfo={REVENUE_DETAILS.revenue} />
      <RevenueCardDetail id={'home-page__revenue-potential'} cardInfo={REVENUE_DETAILS.potential} />
      <RevenueCardDetail id={'home-page__revenue-earnings'} cardInfo={REVENUE_DETAILS.earnings} />
    </Grid>
  );
}

export { RevenueCardDetailsSection };
